import { gatewayService } from "@/common/api.service"
import { gatewayStatus } from "@/constants/gatewayStatus"
import { merchantType } from "@/constants/merchantType"
import {gatewayTypes} from "@/constants/gatewayTypes";

const initialStates = {
    status: 'loading',
    shop_data_gateway : {
        status: 'loading',
        data: [],
    },
    show_gateway_status : false ,
    gateways: [],
    payment_helper_shops: {
        status: 'loading',
        data: [],
    },
    has_cart_gateway: false,
    form_data: {
        farsi_name: '',
        english_name: '',
        subcategory_code: '',
        address: '',
        telephone: '',
        namad_services_code: [],
        logo: '',
        sheba: [],
        merchant_share_percent: '',
        site_address: '',
        callback_address: '',
        can_be_sent_to_shaparak:false,
        show_psp_report_to_user: 0,
        has_enamad: false,
        province_code: null,
        city_code: null,
    },
    namadGatewayDetails: {},
    namad_error: '',
    reportStatistics: {
        number: 0,
        total_transactions: 0,
        terminal_title: '-',
        last_updated: '-',
    },
    tax_data: {},
    tax_data_status: '',
    legal_gateways: {},
    goToTab: 1,
    ivrs: [],
    card_to_cards: [],
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, gateways) {
        state.status       = 'success'
        state.gateways = gateways
    },
    fail(state) {
        state.status       = 'fail'
        state.gateways = []
    },
    setFormData(state, form_data) {
        state.status = 'setFormData'
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key){
            if(key == 'sheba') {
                state.form_data[key] = []
            }else {
                state.form_data[key] = ''
            }
        });
    },
    namadGatewayDetails(state, namadGatewayDetails) {
        state.status = 'successNamadDetails'
        state.namadGatewayDetails = namadGatewayDetails
    },
    namad_error(state) {
        state.status = 'namad_error'
    },
    transactionsReportStatistics(state, reportStatistics) {
        state.status = 'successReport'
        state.reportStatistics = reportStatistics
    },
    hasCartGateway(state, has_cart_gateway) {
        state.has_cart_gateway = has_cart_gateway
    },
    setTaxData(state, tax_data) {
        state.tax_data_status = 'setTaxData'
        state.tax_data = tax_data
    },
    loadTaxData(state) {
        state.tax_data_status = 'loading'
    },
    set_payment_helper_shops(state, data) {
        state.payment_helper_shops.data = data;
        state.payment_helper_shops.status = 'success';
    },
    reset_payment_helper_shops(state) {
        state.payment_helper_shops.status = 'loading';
        state.payment_helper_shops.data = [];
    },
    setShopData(state, data) {
        state.shop_data_gateway.data   = data;
        state.shop_data_gateway.status = 'success';
    },
    resetShopData(state) {
        state.shop_data_gateway.status = 'loading';
        state.shop_data_gateway.data   = [];
    },
    gatewayTab(state, data) {
        state.goToTab = data
    },
    setIvrs(state, data) {
        state.ivrs= data
    },
    setCardToCards(state, data) {
        state.card_to_cards= data
    }
}

const getters = {
    status: ({status}) => status,
    ivrs: ({ivrs}) => ivrs,
    card_to_cards: ({card_to_cards}) => card_to_cards,
    gateways: ({gateways}) => gateways,
    payment_helper_shops: ({payment_helper_shops}) => payment_helper_shops.data,
    payment_helper_shops_status:  ({payment_helper_shops}) => payment_helper_shops.status,
    form_data: ({form_data}) => form_data,
    shop_data_gateway: ({shop_data_gateway}) => shop_data_gateway.data,
    shop_data_gateway_status:  ({shop_data_gateway}) => shop_data_gateway.status,
    active_gateways: ({gateways}) => {
        if(gateways.data) {
            return gateways.data.filter(gateway =>
                gateway.status === gatewayStatus.ACTIVE
            )
        }

        return gateways.filter(gateway => 
            gateway.status === gatewayStatus.ACTIVE
        )
    },
    namadGatewayDetails: state =>state.namadGatewayDetails,
    namad_error: state =>state.namad_error,
    reportStatistics: state => state.reportStatistics,
    hasCartGateway: state => state.has_cart_gateway,
    tax_data_status: state =>state.tax_data_status,
    tax_data: state =>state.tax_data,
    legal_gateways: ({gateways}) => {
        if(gateways.data) {
            return gateways.data.filter(gateway =>
                gateway.merchant_type === merchantType.LEGAL &&
                gateway.status === gatewayStatus.ACTIVE
            )
        }
        return gateways.filter(gateway =>
            gateway.merchant_type === merchantType.LEGAL &&
            gateway.status === gatewayStatus.ACTIVE
        )
    },
    get_gateway_tab: (state) => state.goToTab
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return gatewayService.fetch().then(response => {
            // some backend branches return a bare list, others wrap it as { gateways, has_cart_gateway }
            const payload = response.data.data;
            const gateways = Array.isArray(payload) ? payload : payload.gateways;
            commit('success', gateways);
            let ivrs = [];
            let card_to_cards = [];
            gateways.map((item) => {
                if (item.gateway_type === gatewayTypes.IVR) ivrs.push(item);
                else if (item.gateway_type === gatewayTypes.CARD_TO_CARD)
                    card_to_cards.push(item);
            });
            commit('setIvrs', ivrs)
            commit('setCardToCards', card_to_cards)

            commit('hasCartGateway', payload.has_cart_gateway)
        })
    },
    fetchByUserId({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id
        }
        return gatewayService.fetch(params).then(response => {
            commit('success', response.data.data)
        })
    },
    fetchUserGateways({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id,
            'perpage': 1000,
        }
        return gatewayService.fetch(params).then(response => {
            commit('success', response.data.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')

        return gatewayService.find(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    },
    fetchNamad({commit}, hashid) {
        commit('loading')
        return gatewayService.fetchNamad(hashid).then(
            response => {
                commit('namadGatewayDetails', response.data.data)
            })
            .catch(response => {
                commit('namad_error')
            })
    },
    fetchReportStatistics({commit}, data) {
        commit('loading')
        return gatewayService.fetchReportStatistics(data.shop_id,data.psp).then(
            response => {
                commit('transactionsReportStatistics', response.data.data)
            })
    },
    fetchTaxData({commit}, hashid) {
        commit('loadTaxData')
        return gatewayService.fetchTaxData(hashid).then(response => {
            commit('setTaxData', response.data.data)
        })
    },
    get_payment_helper_shops({commit}) {
        gatewayService.get_payment_helper_shops().then((response) => {
            commit('set_payment_helper_shops', response.data.data);
        });
    },
    fetchShopData({commit}) {
        commit('resetShopData')
        gatewayService.getGatewayUsers().then(response => {
            commit('setShopData', response.data.data);
        })
    },

    gatewayTab({commit}, currentTab) {
        commit('gatewayTab', currentTab)
    }

}
export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}
